export const BASE_URL = import.meta.env.VITE_API_URL + '/pytask_api';

export const feedbackOptions = {
    theme: [
      { label: 'The problem is clearly relevant to the theme and the theme is explicitly used throughout the problem statement.', value: 1.0 },
      { label: 'The problem is clearly relevant to the theme, but the theme is not explicitly used throughout the problem statement.', value: 0.5 },
      { label: 'The problem is irrelevant to the theme.', value: 0.0 },
    ],
    concepts: [
      { label: 'All the given programming concepts are strictly required to solve the problem.', value: 1.0 },
      { label: 'Only a subset of the given programming concepts is required to solve the problem.', value: 0.5 },
      { label: 'None of the given programming concepts is required to solve the problem.', value: 0.0 }
    ],
    comprehensible: [
      { label: 'All neccessary information is provided in the problem statement to solve the problem.', value: 1.0 },
      { label: 'Critical information is not provided in the problem statement to solve the problem.', value: 0.0 }
    ],
    difficulty: [
      { label: 'Easy', value: 0.0 },
      { label: 'Medium', value: 0.5 },
      { label: 'Hard', value: 1.0 }
    ],
    interestingness: [
      { label: 'Interesting', value: 1.0 },
      { label: 'Okay', value: 0.5 },
      { label: 'Boring', value: 0.0 }
    ]
};